import { ISort } from '@/components/table/types';
import { Dispatch, SetStateAction } from 'react';
import styled from 'styled-components';
import FooterModal from '../../../footer';
import { ProgressBar } from '../../../progressBar';
import { Status } from '../../../status';
import { ImportWrapper } from '../../../styles';
import { investorEntitiesSteps } from '../../constants';
import { IHouseholdComparison, IHouseholdResponse, TypeWindow } from '../../types';
import { investorHouseholdsStatusError, investorHouseholdsStatusSuccess } from './constants';
import Table from './table/table';

interface InvestorHouseholdsProps {
  importSteps: typeof investorEntitiesSteps;
  prevStep: () => void;
  nextStep: () => void;
  investorData: IHouseholdResponse | null;
  errors: IHouseholdComparison[];
  sort: ISort;
  setSort: Dispatch<SetStateAction<ISort>>;
  search: string;
  onChangeSearch: (value: string) => void;
  primaryFilter: string;
  showTable: boolean;
  setShowTable: Dispatch<SetStateAction<boolean>>;
  changePrimaryFilterValue: (filter: string) => void;
  openInvestorImportDetailPage: (type: TypeWindow, row: IHouseholdComparison) => void;
}

export const InvestorHouseholds = ({
  importSteps,
  prevStep,
  nextStep,
  investorData,
  errors,
  sort,
  setSort,
  search,
  onChangeSearch,
  primaryFilter,
  showTable,
  setShowTable,
  changePrimaryFilterValue,
  openInvestorImportDetailPage
}: InvestorHouseholdsProps) => {
  if (!investorData) {
    return <></>;
  }

  return (
    <>
      <ImportWrapper>
        <ProgressBar importSteps={importSteps} />
        <Status
          errorsCount={errors.length || null}
          matched={[
            { count: investorData.newHouseholdsCount, text: 'New Investor Households' },
            { count: investorData.updatedHouseholdsCount, text: 'Updated Investor Households' },
            { count: investorData.householdsToDeleteCount, text: 'Households To Delete' }
          ]}
          showTable={showTable}
          setShowTable={setShowTable}
          startOver={prevStep}
          confirmButton={{ name: 'Continue', onClick: nextStep, disabled: Boolean(errors.length) }}
          success={{ ...investorHouseholdsStatusSuccess, viewAll: primaryFilter === 'Updates Only' ? 'View All Updates' : 'View All' }}
          error={investorHouseholdsStatusError}
        />
      </ImportWrapper>
      {showTable || errors?.length ? (
        <TableWrapper>
          <Table
            tableData={investorData.householdComparisons}
            openInvestorImportDetailPage={openInvestorImportDetailPage}
            sort={sort}
            setSort={setSort}
            search={search}
            onChangeSearch={onChangeSearch}
            primaryFilter={primaryFilter}
            changePrimaryFilterValue={changePrimaryFilterValue}
          />
        </TableWrapper>
      ) : (
        <></>
      )}
      {errors?.length || showTable ? (
        <FooterModal
          startOver={prevStep}
          startOverButtonName="Back"
          confirmButton={{ name: 'Continue', onClick: nextStep, disabled: Boolean(errors.length) }}
        />
      ) : (
        <></>
      )}
    </>
  );
};

const TableWrapper = styled.div`
  margin-bottom: 100px;
`;
